<script>
import { cloneDeep } from 'lodash-es';
import { mapActions } from 'vuex';
import NonDynamicTransportLuggageRow from './NonDynamicTransportLuggageRow';

export default {
  name: 'NonDynamicTransportLuggage',
  components: {
    NonDynamicTransportLuggageRow,
  },
  props: {
    transportId: {
      type: Number,
      default: null,
    },
    transportLuggage: {
      type: Array,
      default: () => [],
    },
    luggageTypes: {
      type: Array,
      required: true,
    },
    defaultLuggage: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showLuggageModal: false,
      localLuggage: [],
    };
  },
  created() {
    if (!this.transportLuggage.length) {
      this.localLuggage.push(cloneDeep(this.defaultLuggage));
    } else {
      this.localLuggage = [...this.transportLuggage];
    }
  },
  watch: {
    transportLuggage: {
      handler(value) {
        const localTransportLuggage = cloneDeep(value);
        this.localLuggage = [...localTransportLuggage];
      },
    },
  },
  methods: {
    ...mapActions({
      syncTransportLuggage: 'nonDynamicTransport/syncTransportLuggage',
    }),
    updateLuggage(event) {
      const luggage = [...this.localLuggage];
      luggage[event.index][event.attribute] = event.value;
      this.localLuggage = [...luggage];
    },
    addLuggageRow() {
      this.localLuggage.push(cloneDeep(this.defaultLuggage));
    },
    deleteLuggageRow(index) {
      const luggage = [...this.localLuggage];
      luggage.splice(index, 1);
      this.localLuggage = [...luggage];
    },
    saveLuggage() {
      const payload = { transportId: this.transportId, transportLuggage: this.localLuggage };
      this.syncTransportLuggage(payload);
    },
  },
};
</script>

<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="showLuggageModal"
      width="1300"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          :disabled="!transportId"
          v-on="on"
        >
          <v-icon left>work</v-icon>Add luggage
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Add luggage to transport
        </v-card-title>
        <v-progress-linear v-if="loading" indeterminate/>
        <non-dynamic-transport-luggage-row
          v-else
          v-for="(luggage, index) in localLuggage"
          :key="`non-dynamic-transport-luggage-row-${index}`"
          :luggage="luggage"
          :index="index"
          :luggage-types="luggageTypes"
          @update="updateLuggage"
          @add="addLuggageRow"
          @delete="deleteLuggageRow"
        />

        <v-spacer/>

        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="success"
            @click="saveLuggage"
          >
            {{ $t('buttons.save') }}
          </v-btn>
          <v-btn
            color="primary"
            @click="showLuggageModal = false"
          >
            {{ $t('buttons.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportLuggage.vue